import { audienceOutcomes, idealAudiences, signatureTalks, speakingFormats } from '../../content/siteContent';
import { AnimatedSection } from '../components/AnimatedSection';
import { BookingCta } from '../components/BookingCta';

export function SpeakingPage() {
  return (
    <>
      <header className="page-hero speaking-hero">
        <p className="eyebrow">Keynotes · Workshops · Programs</p>
        <h1>Speaking</h1>
        <p className="page-hero__lead">Conversations that move people from passive knowing to embodied practice.</p>
      </header>

      <AnimatedSection className="signature-talks" aria-labelledby="signature-talks-title">
        <div className="section-heading"><div><p className="eyebrow">The work</p><h2 id="signature-talks-title">Signature talks</h2></div></div>
        <div className="signature-talk-list">
          {signatureTalks.map((talk, index) => (
            <article key={talk.title}>
              <span>0{index + 1}</span>
              <div>
                <h2>{talk.title}</h2>
                <h3>{talk.shortTitle}</h3>
                <p>{talk.description}</p>
                {index === 0 && (
                  <div className="talk-video">
                    <iframe
                      src="https://www.youtube-nocookie.com/embed/Mvn_1kniSsk"
                      title="Beyond the Diagnosis presentation"
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                    <a
                      className="text-link talk-video__link"
                      href="https://www.youtube.com/watch?v=Mvn_1kniSsk"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Watch on YouTube
                    </a>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </AnimatedSection>

      <AnimatedSection className="speaking-details">
        <div><p className="eyebrow">Formats</p><h2>Built to meet the room.</h2><ul>{speakingFormats.map((format) => <li key={format.title}><strong>{format.title}</strong><span>{format.detail}</span></li>)}</ul></div>
        <div><p className="eyebrow">Ideal audiences</p><ul>{idealAudiences.map((audience) => <li key={audience}>{audience}</li>)}</ul></div>
      </AnimatedSection>

      <AnimatedSection className="takeaways-section" aria-labelledby="takeaways-title">
        <p className="eyebrow">What audiences take with them</p>
        <h2 id="takeaways-title">Useful before they leave the room.</h2>
        <ul>{audienceOutcomes.map((outcome) => <li key={outcome}>{outcome}</li>)}</ul>
      </AnimatedSection>

      <div className="download-band">
        <span>Credentials, topics, and booking details</span>
        <a className="button" href="/media/christina-barea-speaker-one-sheet.pdf" download>Download speaker sheet</a>
      </div>
      <BookingCta />
    </>
  );
}
